var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"background-color":"black"},style:(_vm.styleSizeName)},[_c('LivePlayer',{attrs:{"videoUrl":_vm.videoUrl,"fluent":"","autoplay":"","live":"","stretch":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }